(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  function initAftershedReviews(root = document) {
    root.querySelectorAll('.as-rv').forEach(section => {
      if (section.dataset.reviewsReady) return;
      section.dataset.reviewsReady = 'true';
      const cards = Array.from(section.querySelectorAll('.as-rv__card'));
      const more = section.querySelector('.as-rv__more');
      const status = section.querySelector('.as-rv__progress');
      if (!more || cards.length <= 12) return;
      let visible = 12;
      const update = () => {
        cards.forEach((card, index) => { card.hidden = index >= visible; });
        more.hidden = visible >= cards.length;
        status.textContent = `Showing ${Math.min(visible, cards.length)} of ${cards.length} reviews`;
      };
      update();
      more.addEventListener('click', () => {
        const firstNew = cards[visible];
        visible += 12;
        update();
        if (firstNew) {
          firstNew.setAttribute('tabindex', '-1');
          firstNew.focus({ preventScroll: true });
        }
      });
    });
  }
  initAftershedReviews();
  document.addEventListener('shopify:section:load', event => initAftershedReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
